import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, spacing }) => ({
  root: {
    overflow: 'hidden'
  },
  name: {
    overflow: 'hidden'
  },
  avatar: ({ backgroundColor }) => ({
    color: palette.getContrastText(backgroundColor),
    backgroundColor,
    width: 30,
    height: 30,
    fontSize: '.5em'
  }),
  link: {
    textDecoration: 'none',
    fontWeight: '500',
    color: 'inherit'
  }
}))
